<template>
    <div class="notification-box" :id="'notification-box-'+type" v-if="this.data.items && show">
      <div class="notification-box-head"><div v-html="data.header"></div><div class="notification-box-close" @click="closeNotificationBox"></div></div>
      <div class="notification-box-items">
          <div v-for="(item, i) in data.items" :key="i" class="notification-box-item" v-html="item"></div>
      </div>
    </div>
</template>

<script>
export default {
	name: 'Notification',
	props: ['type'],
	data() {
		return {
			data: [],
            show: false,
		}
	},
	methods: {
		async fetchData() {
            if (this.$cookies.get('ws-hidden-notification-'+this.type)) return;
			this.data = await this.dispatchWaitAndNotify('fetchNotifications', this.type, true, true);
            this.show = true;
		},
        closeNotificationBox() {
            this.show = false;
            this.$cookies.set('ws-hidden-notification-'+this.type,'yep','4h');
        },
	},
	mounted() {
		this.fetchData();
	},
}
</script>